/*
 * Type-to-find in an operator picker, matching the Mandanten assignee pickers
 * (AssigneeFilter, AssignClientModal): a case-insensitive substring match on
 * the operator's display name, which is the option label here.
 */
export const matchesOperatorName = (
  input: string,
  option?: { label?: unknown }
) =>
  String(option?.label ?? "")
    .toLowerCase()
    .includes(input.toLowerCase());
